import { NavLink, Link } from 'react-router-dom';
import { useGlobalContext } from '@/shared/contex/contex';
import './Header.css';
import { useMemo } from 'react';
import { useThemeType } from '@gravity-ui/uikit';
import { PasswordTopic } from '@/shared/const/topic';

export function Header({ className = '' }: { className?: string }) {
    const { state, dispatch } = useGlobalContext();
    const theme = useThemeType();
    const labels = {
        idle: 'Не подключено',
        connecting: 'Подключение',
        ready: 'На связи',
        reconnecting: 'Переподключение',
        error: 'Ошибка связи',
    };
    const adminPassword = useMemo(() => localStorage.getItem(PasswordTopic.ADMIN) || '', []);

    return (
        <header className={`Header ${className}`}>
            <div className="header-inner">
                <Link to="/" className="brand" title="На главную">
                    <span className="brand-mark" aria-hidden="true">
                        л/м
                    </span>
                    <span>
                        Локомотив<small>Управление макетом</small>
                    </span>
                </Link>
                <nav className="header-nav" aria-label="Основная навигация">
                    <NavLink to="/" end>
                        Главная
                    </NavLink>
                    {adminPassword && <NavLink to="/admin">Администрирование</NavLink>}
                </nav>
                <div className="header-tools">
                    <span
                        className={`connection connection-${state.statusMqtt || 'idle'} ${state.statusMqtt === 'ready' ? 'online' : ''}`}
                        role="status"
                    >
                        <i />
                        {labels[state.statusMqtt || 'idle']}
                    </span>
                    <Link className="settings-toggle" to="/?tab=settings" aria-label="Настройки" title="Настройки">
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                            <path d="m9.5 3-.6 2.2-1.6.9-2.2-.6-2.5 4.3 1.6 1.6v1.8l-1.6 1.6 2.5 4.3 2.2-.6 1.6.9.6 2.2h5l.6-2.2 1.6-.9 2.2.6 2.5-4.3-1.6-1.6v-1.8l1.6-1.6-2.5-4.3-2.2.6-1.6-.9L14.5 3z" />
                            <circle cx="12" cy="12" r="3" />
                        </svg>
                    </Link>
                    <button
                        className="theme-toggle"
                        aria-label="Переключить тему"
                        title="Переключить тему"
                        onClick={() =>
                            dispatch({
                                type: 'changeTheme',
                                payload: theme === 'dark' ? 'light' : 'dark',
                            })
                        }
                    >
                        {theme === 'dark' ? '☀' : '☾'}
                    </button>
                </div>
            </div>
        </header>
    );
}
